import React from 'react';
export const Date = ({ title, ...rest }) => (
  <svg viewBox="0 0 500 461.538" {...rest}>
    {title && <title>{title}</title>}
    <path d="M423.077 38.462h-38.462V0h-38.461v38.462H153.846V0h-38.461v38.462H76.923C34.615 38.462 0 73.077 0 115.385v269.23c0 42.308 34.615 76.923 76.923 76.923h346.154c42.308 0 76.923-34.615 76.923-76.923v-269.23c0-42.308-34.615-76.923-76.923-76.923zm38.461 346.153c0 21.209-17.254 38.462-38.461 38.462H76.923c-21.207 0-38.461-17.253-38.461-38.462V211.538h423.076v173.077zm0-211.538H38.462v-57.692c0-21.208 17.254-38.462 38.461-38.462h38.462v38.462h38.461V76.923h192.308v38.462h38.461V76.923h38.462c21.207 0 38.461 17.254 38.461 38.462v57.692z" />
  </svg>
);
